import React from "react";
import styles from "./clientScrollSection.css";

interface Props {
  label: string;
  LabelAction?: JSX.Element | boolean;
}
export const ClientScrollSection = ({
  label,
  LabelAction,
  children
}: React.PropsWithChildren<Props>) => {
  return (
    <div className={styles.content}>
      <div className={styles["label-container"]}>
        <p className={styles.label}>{label}</p>
        {LabelAction}
      </div>
      {children}
    </div>
  );
};
